import getNavStructureDefault from './getNavStructureDefault'
import getNavStructureDropdown from './getNavStructureDropdown'
import getNavStructureMobile from './getNavStructureMobile'


const getNavFromStructure = ({ root, structure, collections = null, isDropdown = false, isMobile = false }) => {

  if (!Array.isArray(structure)) {
    return []
  }

  if (isMobile) {
    return getNavStructureMobile({ root, structure, collections })
  }

  if (isDropdown) {
    return getNavStructureDropdown({ root, structure })
  }

  return getNavStructureDefault({ root, structure })
}


export default getNavFromStructure
